import { Filter } from '../models/filter.model';
import { ItemService } from './item.service';
import { FilterHelper } from '../helpers/filter.helper';
import { FilterOption } from '../interfaces/filteroption.interface';
import { Injectable } from '@angular/core';

@Injectable()
export class FilterCountService {
  constructor(
    private itemService: ItemService,
    private filterHelper: FilterHelper,
  ) {}

  /**
   *
   * @param filters
   * @returns {Filter[]}
   */
  calculateCounts(filters: Filter[]): Filter[] {
    return filters.map((filter: Filter, filterTypeIndex: number) => {
      // Clone the filter type
      const filterCopy = filter.clone();

      filterCopy.options.forEach(
        (filterOption: FilterOption, filterOptionIndex: number) => {
          const filtersCopy: Filter[] = filters.map((aFilter: Filter) =>
            aFilter.clone(),
          );

          const newFilterOption = filterOption.clone();

          newFilterOption.active = true;
          filtersCopy[filterTypeIndex].options[filterOptionIndex] =
            newFilterOption;
          const filteredWalks = this.filterHelper.filter(
            this.itemService.items,
            filtersCopy,
          );
          const newFilter = filter.clone();
          newFilter.options = [newFilterOption];
          filterOption.count = this.filterHelper.filter(filteredWalks, [
            newFilter,
          ]).length;
        },
      );

      return filterCopy;
    });
  }
}
